import React, { useState, useEffect } from 'react'
import propTypes from 'prop-types'

import Http from '../../../shared/http'
import RiskProfileWidget from '../../../risk_profile/RiskProfileWidget'
import { ExternalRiskProfile } from '../ExternalRiskProfile'
import { ExternalRiskProfileProptypes } from '../ExternalRiskProfile'
import { OnboardingRiskProvider } from './context'

export const OnboardingRiskProfile = ({ useExternalRiskProfiling, updateExternalRiskPath, ...rest }) => {
  const [riskProfile, setRiskProfile] = useState(rest.riskProfile)
  const updateRiskHandler = buildUpdateRiskHandlerFunction(updateExternalRiskPath, setRiskProfile)

  useEffect(hideNextButton, [])

  return (
    <OnboardingRiskProvider {...rest}>
      { useExternalRiskProfiling
        ? <ExternalRiskProfile {...rest} updateRiskHandler={updateRiskHandler} riskProfile={riskProfile} />
        : <RiskProfileWidget {...rest}/>
      }
    </OnboardingRiskProvider>
  )
}

const buildUpdateRiskHandlerFunction = (updateExternalRiskPath, setRiskProfile) => {
  return async (riskProfile) => {
    const response = await Http.request(updateExternalRiskPath, 'POST', JSON.stringify(riskProfile))
    if (response.ok){
      const data = await response.json()
      const { risk_profile } = data
      showNextButton()
      setRiskProfile(risk_profile)
    } else {
      console.log('Something went wrong updating the risk profile')
    }
  }
}

const hideNextButton = () => {
  const nextButton = document.querySelector('#next-button')
  if (nextButton) {
    nextButton.classList.add('hide')
    nextButton.innerHTML = 'Done'
  }
}

const showNextButton = () => {
  const nextButton = document.querySelector('#next-button')
  if (nextButton) {
    nextButton.classList.remove('hide')
    nextButton.innerHTML = 'Done'
  }
}

export const OnboardingRiskProfileProptypes = {
  ...ExternalRiskProfileProptypes,
  useExternalRiskProfiling: propTypes.object.isRequired,
  updateExternalRiskPath: propTypes.string.isRequired,
  userDetails: propTypes.object.isRequired,
  tenant: propTypes.string.isRequired,
  colors: propTypes.object.isRequired
}

OnboardingRiskProfile.propTypes = OnboardingRiskProfileProptypes
